import { FC } from 'react';
// import cs from 'classnames';
import styles from './index.module.less';
// import Evaluations from './Evaluations';
import Evaluations from '@/common/components/business/AreaDetailDrawer/components/FirstScreenRight/components/Evaluations';
import Basic from './Basic';

/**
 * @Description 商圈详情概览
 */
const AreaOverview: FC<{
  overViewData: any;
  detail: any;
  mapIns: any;
  rangeMarkerRef: any;
  tenantId: string;
  setIsOpenHeatMap: (isOpen: boolean) => void;
  configSwitch: any;
  shareParams: any;
  isSemirModel: boolean;
  spotEvaluationConfig: any;
}> = ({
  overViewData,
  detail,
  mapIns,
  rangeMarkerRef,
  tenantId,
  setIsOpenHeatMap,
  configSwitch,
  shareParams,
  isSemirModel = false,
  spotEvaluationConfig
}) => {
  // scoreDisplay: 1-展示，2-不展示 默认展示
  const showEvaluations = Number(spotEvaluationConfig?.scoreDisplay) === 1;

  /** 是否展示预测横幅 */
  const showPredictingBanner = Number(spotEvaluationConfig?.storeOperationAnalysisDisplay) === 1;

  return (
    <div className={styles.mainBacCon}>
      {/* 评分 */}
      {showEvaluations && (
        <Evaluations
          detail={detail}
          overView={overViewData}
          picList={detail?.picList || []}
          configSwitch={configSwitch}
          shareParams={shareParams}
          provideFor='spotevaluation'
          isSemirModel={isSemirModel}
          showPredictingBanner={showPredictingBanner}
        />
      )}
      {/* 明细 */}
      <Basic
        detail={detail}
        mapIns={mapIns}
        rangeMarkerRef={rangeMarkerRef}
        tenantId={tenantId}
        setIsOpenHeatMap={setIsOpenHeatMap}
      />
    </div>
  );
};

export default AreaOverview;
